<script>
    console.log(`Initializing Head`)
    console.log("Head initialized")
</script>

<style>
    div {
        color: purple;
    }
    .slot {
        color: rgb(220, 0, 0);
    }
</style>

<div>
    <slot name="title" class="slot">My Cool App</slot>
    <slot>cool description</slot>
</div>
